import script from "./RomanFov.vue?vue&type=script&setup=true&lang=ts"
export * from "./RomanFov.vue?vue&type=script&setup=true&lang=ts"

import "./RomanFov.vue?vue&type=style&index=0&id=89e93b9e&lang=less"

const __exports__ = script;

export default __exports__